import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const EcomPhoneWUT = props => {
  const fieldType = FIELD_TYPES.ECOM_PHONE;
  const addressPhoneLabel = useAddressLabel('phone');
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    type: "phone",
    fieldType: fieldType,
    label: addressPhoneLabel
  }));
};
//# sourceMappingURL=ecom-phone-wut.js.map